import React from 'react'
import anime from 'animejs';
import { Link } from 'react-router-dom'
import './Menu_style.css'
import AA from '../Image/AA.png'


export default function Menu() {
    anime({
        targets: '#icons',
        translateX: 110,
        direction: 'alternate',
        loop: true,
        easing: 'spring(1, 80, 10, 0)'
    });

    return (
        <div className='h_container_menu'>
            <div className='vector3_menu'>
                <div className='vector2_menu'>
                    <div className='vector1_menu'>
                        <div className='vector4_menu'>
                            <div className='dysplay_menu'>

                                <div>
                                    <p className='h_p_text_menu'>Freelance3359</p>
                                </div>

                                <div className='block_a_href'>
                                    <i id="icons" className="bi bi-arrow-right-circle" ></i>

                                    <a href="#" className="button">
                                        <div className="button__line"></div>
                                        <div className="button__line"></div>
                                        <Link component={Link} to="/Sait" className="button__text">Сайты</Link>
                                        <div className="button__drow1"></div>
                                        <div className="button__drow2"></div>
                                    </a>

                                    <a href="#" className="button">
                                        <div className="button__line"></div>
                                        <div className="button__line"></div>
                                        <Link component={Link} to="/Videos" className="button__text">Видео</Link>
                                        <div className="button__drow1"></div>
                                        <div className="button__drow2"></div>
                                    </a>

                                </div>
                            </div>

                            <p className='h_block_a_href_block_text'>Выберете что вас интересует из моего портфолио, верстка/доработка сайтов или монтаж видео, shorts видео.</p>

                        </div>
                    </div>
                </div>
            </div>
            <div className='dysplay_menu'>
                <div>
                    <h3 className='h_text_block_Alex' id='text_h3'>Привет всем! Я <br /> Сарычев Алексей</h3>

                    <div className='button__text__none_videos'>
                        <div className='button__text_menu'>
                            <Link component={Link} to="/Videos" className="glow-on-hover_videos">Все видео</Link>
                        </div>

                        <div className='button__text_videos'>
                            <Link component={Link} to="/" className="glow-on-hover_videos">Шаг назад</Link>
                        </div>
                        {/* Кнопка */}
                        <div className='button__text_videos'>
                            <a href="https://tele.click/{Freelance3359}" className="glow-on-hover_videos">Телеграмм</a>
                        </div>
                    </div>



                    <div className='h_text_block_text_block'>
                        <p className='h_text_block_text'>Я фрилансер мне 25 лет , занимаюсь разработкой сайтов 2 года и монтажом различных видео около 3 лет.</p>
                    </div>

                </div>
                <div className='tr'>
                    <div className="oval">
                        <i className="bi bi-rocket-takeoff"></i>
                        <div className="circle"></div>
                    </div>
                </div>

                <div className='block_right'>
                    <img className='block_right_image' src={AA} alt="" />
                </div>

                <p className='h_block_a_href_block_text_text'>Выберете что вас интересует из моего портфолио, верстка и доработка сайтов или монтаж видео, shorts видео.</p>

            </div>
        </div>
    )
}
